// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__1Z8Nj","label":"Labeled_label__2NtlZ","divider":"Labeled_divider__J7rfu"};